var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 55,
    viewBox: "0 0 88 55",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.1692 0C55.2737 0 50.6866 1.24866 46.6866 3.44119C48.9055 5.14212 50.8757 7.13801 52.5573 9.36003C54.9055 8.3965 57.4727 7.86557 60.1692 7.86557C71.1443 7.86557 80.0399 16.6553 80.0399 27.5C80.0399 38.3447 71.1443 47.1344 60.1692 47.1344C49.1941 47.1344 40.2986 38.3447 40.2986 27.5C40.2986 24.4324 41.0249 21.5517 42.2986 18.9659C40.8559 16.58 38.835 14.5865 36.418 13.165C33.8309 17.3436 32.3384 22.2497 32.3384 27.5C32.3384 42.6904 44.7961 55 60.1692 55C75.5424 55 88.0001 42.6904 88.0001 27.5C88.0001 12.3096 75.5424 0 60.1692 0Z",
    fill: "url(#paint0_linear_1_433)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4328 45.6301C33.0846 46.5937 30.5274 47.1246 27.8308 47.1246C16.8557 47.1246 7.9602 38.3348 7.9602 27.4902C7.9602 16.6455 16.8557 7.85574 27.8308 7.85574C38.806 7.85574 47.7015 16.6553 47.7015 27.5C47.7015 30.5676 46.9652 33.4582 45.7015 36.044C47.1443 38.4233 49.1741 40.4192 51.5821 41.835C54.1692 37.6564 55.6617 32.7503 55.6617 27.5C55.6617 12.3096 43.204 0 27.8308 0C12.4577 0 0 12.3096 0 27.5C0 42.6904 12.4577 55 27.8308 55C32.7264 55 37.3234 53.7513 41.3134 51.5588C39.0932 49.8519 37.1153 47.8578 35.4328 45.6301Z",
    fill: "url(#paint1_linear_1_433)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_433",
    x1: 51.8384,
    y1: 5.22225e-8,
    x2: 79.8384,
    y2: 5.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BAA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_433",
    x1: 19.5,
    y1: 5.22225e-8,
    x2: 47.5,
    y2: 5.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD0BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BAA8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing);
export default __webpack_public_path__ + "static/media/ring.265e572c599c90d021f924644735ada2.svg";
export { ForwardRef as ReactComponent };